import type { Product } from "../lib/mockData";
import { ProductCard } from "./ProductCard";

interface ProductCardGroupProps {
  products: Product[];
  onProductSelect?: (product: Product) => void;
}

export function ProductCardGroup({ products, onProductSelect }: ProductCardGroupProps) {
  // Ensure we only display up to 2 products
  const displayProducts = products.slice(0, 2);
  
  return (
    <div className="flex flex-row gap-4 justify-start mt-4">
      {displayProducts.map((product) => (
        <ProductCard 
          key={product.pickedSku ? `${product.id}:${product.pickedSku}` : product.id}
          product={product} 
          onProductSelect={onProductSelect}
        />
      ))}
    </div>
  );
} 